
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';

interface UserAuthCheckProps {
  user: any;
  loading: boolean;
}

const UserAuthCheck = ({ user, loading }: UserAuthCheckProps) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sports-green mx-auto mb-4"></div>
          <p className="text-gray-500">Loading chat...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <Users className="h-12 w-12 mx-auto text-gray-400 mb-4" />
          <p className="text-gray-500 mb-4">Please log in to access chat</p>
          <Button asChild className="bg-sports-green hover:bg-sports-green/90">
            <a href="/login">Sign In</a>
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default UserAuthCheck;
